var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal() {
        _classCallCheck(this, Modal);

        return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
    }

    _createClass(Modal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                headerIcon = _props.headerIcon,
                headerText = _props.headerText,
                warning = _props.warning,
                showModal = _props.showModal,
                buttons = _props.buttons;


            var modalClassName = classNames({
                'modal-show': showModal,
                'modal-hide': !showModal
            });
            var engineContainerClasses = classNames('engine-modal-container', {
                'modal-warning': warning
            });

            var renderButtons = void 0;
            if (!buttons) {
                renderButtons = React.createElement(
                    'button',
                    {
                        className: 'btn btn-primary pull-right',
                        type: 'button',
                        onClick: this.props.onClickCallback
                    },
                    'Lukk'
                );
            } else {
                renderButtons = buttons;
            }

            return React.createElement(
                'div',
                { className: modalClassName },
                React.createElement(
                    'div',
                    { className: engineContainerClasses },
                    React.createElement(
                        'div',
                        { className: 'engine-modal-header' },
                        headerIcon && React.createElement(
                            'div',
                            { className: 'engine-modal-header-icon' },
                            React.createElement('i', { className: headerIcon })
                        ),
                        React.createElement(
                            'div',
                            { className: 'engine-modal-header-text' },
                            headerText
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'engine-modal-content' },
                        React.createElement(
                            'div',
                            { className: 'engine-modal-content-text' },
                            this.props.children
                        ),
                        React.createElement(
                            'div',
                            { className: 'engine-modal-header-button' },
                            renderButtons
                        )
                    )
                )
            );
        }
    }]);

    return Modal;
}(Component);

Modal.propTypes = {
    headerIcon: PropTypes.string,
    headerText: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    showModal: PropTypes.bool.isRequired,
    onClickCallback: PropTypes.func,
    warning: PropTypes.bool,
    buttons: PropTypes.arrayOf(PropTypes.element)
};


export default Modal;